import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Icon } from "@tenant/ui";
import clsx from "clsx";
import styles from "./HomeVacationRentalTag.module.scss";
import { TenantIconNameEnum } from "@/types/tenantIcons";

export const HomeVacationRentalTag = ({
  className,
}: {
  className?: string;
}) => {
  const [block] = useModuleBEM(styles, "HomeVacationRentalTag");
  const { t } = useI18nContext();

  return (
    <div className={clsx(block, className)}>
      <Icon iconName={TenantIconNameEnum.home} aria-hidden />
      <p>{t("core-hotels.homes.vacationRental")}</p>
    </div>
  );
};
